/**
 * Canonical scroll-to-top utility.
 * Scrolls window + all known layout containers to top.
 * 
 * Replaces 4 separate inline implementations that existed in:
 * - FeedRefreshContext.jsx
 * - Header.js
 * - useScrollToTopOnMount.js
 * - ScrollManager.js
 * 
 * @param {string} behavior - 'instant' (default) or 'smooth'
 */
const SCROLL_SELECTORS = [
  '.layout-content',
  '.feed-wrapper',
  '.main-scroll-container',
  '.content-container.full-width',
  '.content-container'
];

const INSTANT_SCROLL_CLASS = 'instant-scroll';

const getScrollTargets = () => {
  const targets = new Set([document.documentElement, document.body]);
  const seen = new Set();

  SCROLL_SELECTORS.forEach(sel => {
    try {
      document.querySelectorAll(sel).forEach(el => {
        if (!el || seen.has(el)) return;
        seen.add(el);
        targets.add(el);
      });
    } catch {}
  });

  return targets;
};

const setInstantScrollClass = (enabled) => {
  getScrollTargets().forEach(el => {
    try {
      if (enabled) el.classList.add(INSTANT_SCROLL_CLASS);
      else el.classList.remove(INSTANT_SCROLL_CLASS);
    } catch {}
  });
};

export const scrollAllToTop = (behavior = 'instant') => {
  const useInstantClass = behavior === 'instant' || behavior === 'auto';

  if (useInstantClass) setInstantScrollClass(true);

  try {
    window.scrollTo({ top: 0, left: 0, behavior });
  } catch {
    try { window.scrollTo(0, 0); } catch {}
  }

  try {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  } catch {}

  const seen = new Set();
  SCROLL_SELECTORS.forEach(sel => {
    try {
      document.querySelectorAll(sel).forEach(el => {
        if (!el || seen.has(el)) return;
        seen.add(el);
        if (typeof el.scrollTo === 'function') {
          el.scrollTo({ top: 0, left: 0, behavior });
        } else {
          el.scrollTop = 0;
        }
      });
    } catch {}
  });

  if (useInstantClass) setInstantScrollClass(false);
};
